import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import reportAxios from '../../../axios/report'

export const reportPerformanceform = recordData => {
  return dispatch => {
    dispatch(reportPerformanceformStart())

    reportAxios
      .post('/report_performance_form', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report PERFORMANCE_FORM',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportPerformanceformSuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportPerformanceformFailed())
      })
  }
}

export const reportPerformanceformStart = () => {
  return {
    type: actionTypes.REPORT_PERFORMANCE_FORM_START
  }
}

export const reportPerformanceformSuccess = data => {
  return {
    type: actionTypes.REPORT_PERFORMANCE_FORM_SUCCESS,
    data
  }
}

export const reportPerformanceformFailed = () => {
  return {
    type: actionTypes.REPORT_PERFORMANCE_FORM_FAILED
  }
}

export const clearReportPerformanceform = () => {
  return {
    type: actionTypes.CLEAR_REPORT_PERFORMANCE_FORM
  }
}
